import React from "react";
import useReveal from "../hooks/useReveal";
import PageHero from "../components/PageHero";
import ServicesEditorial from "../components/ServicesEditorial";
import TestimonialsPremium from "../components/TestimonialsPremium";
import CtaPremium from "../components/CtaPremium";
import Logos from "../components/Logos";

export default function ServicesPage() {
  useReveal();
  return (
    <div className="page-enter">
      <PageHero
        variant="light"
        eyebrow="Services — disciplines"
        title="Every discipline."
        italic="Under one roof."
        subtitle="Architecture, structural work, interiors, joinery, electrics, plumbing, roofing and eco retrofits — delivered by a single in-house team."
        image="https://images.pexels.com/photos/9757618/pexels-photo-9757618.png?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=2000"
      />
      <ServicesEditorial />
      <Logos />
      <TestimonialsPremium />
      <CtaPremium />
    </div>
  );
}
